"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdSendBeacon = _interopRequireDefault(require("cccisd-send-beacon"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Boilerplate = window.cccisd.boilerplate;
var savePeriod = 5 * 60 * 1000; // Save events every 5 minutes
var events = [];
function saveEvents() {
  if (events.length === 0) {
    return;
  }

  // we are not waiting for the request finished
  _cccisdAxios["default"].post(Boilerplate.route('api.event-log.store'), {
    timestamp: getCurrentUnixTime(),
    events: events
  });
  events = [];
}
function saveEventsOnUnload() {
  addLastPageVisit();
  if (events.length === 0) {
    return;
  }
  (0, _cccisdSendBeacon["default"])(Boilerplate.route('api.event-log.store'), {
    timestamp: getCurrentUnixTime(),
    events: events
  });
}
function getCurrentUnixTime() {
  return Math.round(new Date().getTime() / 1000);
}
function getUrlHistory() {
  // grab url history from redux
  var store = window.cccisd.store;
  if (!store || !store.getState) {
    return [];
  }
  var urlHistory = (0, _get2["default"])(store.getState(), 'boilerplate.urlHistory');
  if (!urlHistory) {
    return [];
  }
  return urlHistory;
}
function getCurrentUrl() {
  var urlHistory = getUrlHistory();
  if (urlHistory.length === 0) {
    return;
  }
  return urlHistory[urlHistory.length - 1].url;
}
function addLastPageVisit() {
  var urlHistory = getUrlHistory();
  if (urlHistory.length === 0) {
    return;
  }
  var currentTime = new Date().getTime();
  var last = urlHistory[urlHistory.length - 1];
  addEvent({
    eventType: 'pageVisit',
    url: last.url,
    duration: currentTime - last.time,
    metadata: {
      onUnload: true
    }
  });
}

// Save events periodically
setInterval(saveEvents, savePeriod);

// Save events on unload
window.addEventListener('beforeunload', saveEventsOnUnload);
function addEvent(eventData) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (_typeof(eventData) !== 'object' || !eventData.eventType) {
    console.error('eventType is required when saving event log');
    return;
  }
  var data = _objectSpread({
    eventTime: getCurrentUnixTime(),
    url: eventData.url || getCurrentUrl()
  }, (0, _pick2["default"])(eventData, ['eventType', 'targetId', 'targetType', 'metadata', 'duration']));
  events.push(data);
  if (settings.saveImmediately) {
    saveEvents();
  }
}
var _default = addEvent;
exports["default"] = _default;